import axios from "axios";
import { serviceHelper } from "./helper";

const instance = axios.create();

instance.defaults.headers.common["Visoplan-Client-Id"] =
  serviceHelper.getClientId();

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    const isProjectScoped = url.includes("/project/") && !url.endsWith("/project") && !url.includes("/project?");
    if (status === 403 && isProjectScoped) {
      const translated = error.response?.data?.translatedMessage;
      if (translated && typeof window !== "undefined" && typeof window.AlertAPI === "function") {
        window.AlertAPI(translated);
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
